import { useState, useRef, useEffect, useContext } from "react";
import ListOfStoryboards from "../Components/ListOfStoryboards";
import './Home.css'
import { useNavigate } from "react-router-dom"
import createNewProject from "../Services/createNewProject";
import { Button, Footer } from "@nxtvid/component-library"
import { StoryboardStateContext } from "../Contexts/StoryboardStateContext";
import { StoryboardsContext } from "../Contexts/StoryboardsContext";
import { AuthContext } from "../Contexts/AuthContext";
import { UserContext } from "../Contexts/UserContext";
import ListOfRFPs from "../Components/ListofRFPs";
import { MastheadRefContext } from "../Contexts/MastheadRefContext";
import TestimonialsSection from "./TestimonialsSection/TestimonialsSection";

const Home = () => {
  let RFPList = []
  const [RFPs, setRFPs] = useState([])
  const {isAuthenticated} = useContext(AuthContext)
  const {userInfo} = useContext(UserContext)
  const {storyboards, setStoryboards} = useContext(StoryboardsContext)  
  const {setStoryboardState} = useContext(StoryboardStateContext)
  const [storyboardTutorialIndex, setStoryboardTutorialIndex] = useState(0)
  const [RFPTutorialIndex, setRFPTutorialIndex] = useState(0)
  const shotListCreatorImg = require('../Images/shotlist-creator.png')
  const storyboardCreatorImg = require('../Images/storyboard-creator.png')
  const RFPcreatorImg = require('../Images/RFP-creator.png')
  const mobileStoryboardTutorial = [require('../Images/tutorial_images/Storyboard Tutorial Mobile 3.webp'),require('../Images/tutorial_images/Storyboard Tutorial Mobile 4.webp'),require('../Images/tutorial_images/Storyboard Tutorial Mobile 5.webp')]
  const desktopStoryboardTutorial = [require('../Images/tutorial_images/Storyboard Tutorial Desktop 3.webp'),require('../Images/tutorial_images/Storyboard Tutorial Desktop 4.webp'),require('../Images/tutorial_images/Storyboard Tutorial Desktop 5.webp')]
  const mobileRFPTutorial = [require('../Images/tutorial_images/RFP Tutorial Mobile 2.webp'),require('../Images/tutorial_images/RFP Tutorial Mobile 3.webp'),require('../Images/tutorial_images/RFP Tutorial Mobile 4.webp'),require('../Images/tutorial_images/RFP Tutorial Mobile 5.webp')]
  const desktopRFPTutorial = [require('../Images/tutorial_images/RFP Tutorial Desktop 2.webp'),require('../Images/tutorial_images/RFP Tutorial Desktop 3.webp'),require('../Images/tutorial_images/RFP Tutorial Desktop 4.webp'),require('../Images/tutorial_images/RFP Tutorial Desktop 5.webp')]
  const targetSection = useRef(null);
  const greyCarrot = require('../Images/greyCarrot.png')
  const plus_icon=require('../Images/plus-icon.png')
  const nonAuthHomePageImage = require('../Images/nonauth_homepage_image.png')
  const starsIcon = require('../Images/stars-icon.png')
  const {mastheadRef} = useContext(MastheadRefContext)
  const ariAvatar = require('../Images/ari-avatar.png');
  const ajAvatar = require('../Images/aj-avatar.png');
  const storyboardImg = require('../Images/storyboardImg.png');
  const shotlistImg = require('../Images/shotlistImg.png');
  const rfpImg = require('../Images/rfpImg.png');
  const calendarImg = require('../Images/calendarImg.png');
  const handshakeImg = require('../Images/handshakeImg.png');
  const heartMailImg = require('../Images/heartMailImg.png');
  const ctaFabricImg = require('../Images/ctaFabricImg.png');
  const testimonials = [
    {
      testimonial: "We used NXTVid to plan 5 videos across three boutique locations. Ari kept everything organized; budget, timeline, deliverables. Our team in Miami and New York stayed in sync, and we delivered content two weeks early. We’ll never plan videos manually again.",
      role: "Tony F., Luxury Clothing Retailer"
    },
    {
      testimonial: "We thought video production was too expensive — until this.",
      role: "Jay S., Restaurant Owner"
    },
    {
      testimonial: "NXTVid helped us plan a full shoot that looked like a $20K production, but we spent under $3K because everything was pre-planned and streamlined. No wasted time, no re-shoots",
      role: "Jay S., Restaurant Owner"
    },
    {
      testimonial: "We didn’t know where to start — NXTVid gave us a clear plan.",
      role: "Kevin C., Agency Owner"
    },
    {
      testimonial: "Before NXTVid, our team struggled to create video content. AJ turned our rough brainstorm sessions into a professional shot list and storyboard in minutes. It saved us days of back-and-forth emails.",
      role: "Kevin C., Agency Owner"
    },
    {
      testimonial: "We finally stopped winging our content days.",
      role: "Michael M., Founder of Men's Skincare Brand"
    },
    {
      testimonial:'Before NXTVid, our team would scramble to plan shoot days — whiteboards, sticky notes, chaos. Now AJ builds our shot list and storyboard in minutes. We show up knowing exactly what we need to film, and it’s made our social content look way more professional.',
      role: "Michael M., Founder of Men's Skincare Brand"
    }
    
  ];
  

  useEffect(() => {
    if (userInfo._projects) {
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
      const fetchProjects = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/api/getAllProjects`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ userId: userInfo._id }),
          });
          const result = await response.json();
          console.log(result.projects)
          setStoryboards(result.projects);
        } catch (error) {
          console.error('Error fetching projects:', error);
        }
      };
      fetchProjects();
    }
  }, [userInfo]);
  
  

  return (
    <div className="App">
      {isAuthenticated ? 
      <body className="HomePage-Body">
      <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
      <div className="User-Dashboard">
          <div className="Storyboard-Dashboard">
            <div className="Dashboard-Header">
              <h3>Projects</h3>
              <Button icon={plus_icon} label='' className='add-button' onClick={()=>{if(isAuthenticated){createNewProject('Untitled', setStoryboards)} else{ document.getElementsByClassName("sign-in-card")[0].style.display='block'}}} type='primary' size='small'/>
              </div>
            <ListOfStoryboards storyboards={storyboards} setStoryboards={setStoryboards} setStoryboardState={setStoryboardState} RFPs={RFPs}/>
          </div>
          <div className="RFP-Dashboard">
            <div className="Dashboard-Header">
            <h3>RFPs</h3>
            <Button icon={plus_icon} label='' className='add-button' type='primary' size='small' onClick={()=>window.location.href = '/RFPBuilder'}/>
              </div>
              <ListOfRFPs setRFPs={setRFPs} RFPList={RFPList} RFPs={RFPs}/>
          </div>
        </div>
      </body> :
      
<body className="HomePage-Body">
<div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
  <div className="nonauth-body">
    <div
  style={{
    position: 'relative',
    padding: '8rem 8% 6rem',
    background:
      'linear-gradient(180deg, #2b4157 0%, #3d5f82 40%, #4E81AF 62%, #4E81AF 100%)',
    color: '#fff',
    overflow: 'hidden',
    textAlign: 'center',
  }}
>
  {/* Content */}
  <div style={{ maxWidth: '900px', margin: '0 auto', height:'60vh', position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    {/* Eyebrow */}
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        padding: '.4rem .8rem',
        borderRadius: '999px',
        background: 'rgba(255,255,255,.06)',
        border: '1px solid rgba(255,255,255,.1)',
        color: 'rgba(255,255,255,.9)',
        fontWeight: 600,
        fontSize: '.95rem',
      }}
    >
      <img style={{ height: '2.5rem' }} src={starsIcon} alt="" />
    
      <h5 style={{ margin: 0 }}>Video Pre-Production Software</h5>
      </div>

    {/* Title */}
    <h1
      style={{
        margin: '.9rem 0 .6rem',
        fontSize: 'clamp(2.6rem, 6vw, 4.6rem)',
        lineHeight: '1.04',
        fontWeight: 800,
        letterSpacing: '-0.01em',
        color: '#fff',
      }}
    >
      Plan Videos That<br />Grow Your Business
    </h1>

    {/* Subtitle */}
    <h2
      style={{
        marginTop: '1.5rem',
        fontSize: 'clamp(1.05rem, 2.2vw, 1.25rem)',
        color: 'rgba(255,255,255,.92)',
        fontWeight: 500,
        maxWidth: '860px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      Answer a few tailored prompts and get a professional pre-production blueprint in minutes.
    </h2>

    {/* CTAs */}
    <div
      style={{
        marginTop: '2.5rem',
        display: 'flex',
        justifyContent: 'center',
        gap: '0.9rem',
        flexWrap: 'wrap',
      }}
    >
      <Button
        label="Start planning for free"
        type="primary"
        size="medium"
        onClick={() => mastheadRef.current?.triggerSignUpModal?.()}
      />
      <Button
        label="Book a Demo"
        type="destructive"
        size="medium"
        onClick={() => window.open('https://calendly.com/ceo-nxtvid/demo', '_blank')}
      />
    </div>
  </div>

  {/* Orange half-circle blob */}
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: '-100%',
      width: 'min(1400px, 120vw)',
      height: 'min(1400px, 120vw)',
      borderRadius: '50%',
      background:
        'radial-gradient(closest-side, rgba(223,124,82,.62), rgba(223,124,82,.24) 55%, rgba(223,124,82,0) 70%)',
      filter: 'blur(2px)',
      pointerEvents: 'none',
      zIndex: 1,
    }}
  />
</div>


  

  {/* Meet The Strategist */}
<div
  style={{
    padding: '4.5rem 6% 3rem',
    color: '#4F5962',
    fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  }}
>
  {/* Top row: Section title & kicker */}
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '1rem',
      flexWrap: 'wrap',
      marginBottom: '1.75rem',
    }}
  >
    <h2
      style={{
        margin: 0,
        color: '#874B9E',
        fontSize: '2.75rem',
        lineHeight: 1.1,
        fontWeight: 800,
        letterSpacing: '-0.01em',
      }}
    >
      Meet The Strategists
    </h2>

    <p
      style={{
        margin: 0,
        maxWidth: 380,
        fontSize: '1.125rem',
        lineHeight: 1.5,
        color: '#4F5962',
        textAlign: 'left',
      }}
    >
      From production to market ready all in one place
    </p>
  </div>

  {/* Cards */}
  <div
    style={{
      display: 'flex',
      gap: '1.75rem',
      flexWrap: 'wrap',
    }}
  >
    {/* Ari Card */}
    <div
      style={{
        flex: '1 1 420px',
        background: '#2E3446',
        color: 'white',
        borderRadius: 14,
        padding: '1.75rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
      }}
    >
      {/* Avatar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
        <div
          style={{
            width: 110,
            height: 110,
            borderRadius: '50%',
            background: '#E9E1F7',
            display: 'grid',
            placeItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={ariAvatar} // supply your Ari image
            alt="Ari avatar"
            style={{ width: 86, height: 86, objectFit: 'cover' }}
          />
        </div>
      </div>

      {/* Text block */}
      <div style={{ marginTop: '1.25rem' }}>
        <div
          style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: '#DF7C52',
            marginBottom: '.25rem',
          }}
        >
          Ari
        </div>

        <div
          style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: 'rgba(255,255,255,0.95)',
          }}
        >
          Your AI-Powered Script Strategist
        </div>

        <div
          style={{
            marginTop: '.35rem',
            color: 'rgba(255,255,255,0.75)',
            fontSize: '.98rem',
          }}
        >
          Proposal and RFP Generator
        </div>

        {/* Divider */}
        <div
          style={{
            marginTop: '1.1rem',
            height: 1,
            background: 'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />

        {/* Description */}
        <p
          style={{
            marginTop: '1.1rem',
            fontSize: '.98rem',
            lineHeight: 1.6,
            color: 'rgba(255,255,255,0.88)',
          }}
        >
          Ari helps you handle the nuts and bolts: timelines, budgets, logistic and
          deliverables. She transforms your rough ideas into professional, shareable PDFs.
        </p>

        {/* Divider */}
        <div
          style={{
            marginTop: '1.1rem',
            height: 1,
            background: 'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />

        {/* Checks */}
        <div style={{ marginTop: '1rem', display: 'grid', gap: '.5rem' }}>
          {[
            'Timeline planning',
            'Budget organization',
            'Logistics breakdown',
          ].map((text) => (
            <div key={text} style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <span
                aria-hidden
                style={{
                  width: 20,
                  height: 20,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 4,
                  background: '#6DBF67',
                  fontSize: 14,
                  color: '#0b2d0a',
                  fontWeight: 800,
                }}
              >
                ✓
              </span>
              <span style={{ color: 'rgba(255,255,255,0.92)', fontSize: '.98rem' }}>{text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* AJ Card */}
    <div
      style={{
        flex: '1 1 420px',
        background: '#2E3446',
        color: 'white',
        borderRadius: 14,
        padding: '1.75rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
      }}
    >
      {/* Avatar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
        <div
          style={{
            width: 110,
            height: 110,
            borderRadius: '50%',
            background: '#cfdcefff',
            display: 'grid',
            placeItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={ajAvatar} // supply your AJ image
            alt="AJ avatar"
            style={{ width: 86, height: 86, objectFit: 'cover' }}
          />
        </div>
      </div>

      {/* Text block */}
      <div style={{ marginTop: '1.25rem' }}>
        <div
          style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: '#DF7C52',
            marginBottom: '.25rem',
          }}
        >
          Aj
        </div>

        <div
          style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            color: 'rgba(255,255,255,0.95)',
          }}
        >
          Your AI-Powered Campaign Strategist
        </div>

        <div
          style={{
            marginTop: '.35rem',
            color: 'rgba(255,255,255,0.75)',
            fontSize: '.98rem',
          }}
        >
          Story Telling and Brand Builder
        </div>

        {/* Divider */}
        <div
          style={{
            marginTop: '1.1rem',
            height: 1,
            background: 'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />

        {/* Description */}
        <p
          style={{
            marginTop: '1.1rem',
            fontSize: '.98rem',
            lineHeight: 1.6,
            color: 'rgba(255,255,255,0.88)',
          }}
        >
          AJ helps you clarify your brand story and customer targets.
          He ensures your video isn’t just beautiful—it’s built to convert.
        </p>

        {/* Divider */}
        <div
          style={{
            marginTop: '1.1rem',
            height: 1,
            background: 'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />

        {/* Checks */}
        <div style={{ marginTop: '1rem', display: 'grid', gap: '.5rem' }}>
          {[
            'Brand positioning',
            'Storytelling concepts',
            'Customer targeting',
          ].map((text) => (
            <div key={text} style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <span
                aria-hidden
                style={{
                  width: 20,
                  height: 20,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 4,
                  background: '#6DBF67',
                  fontSize: 14,
                  color: '#0b2d0a',
                  fontWeight: 800,
                }}
              >
                ✓
              </span>
              <span style={{ color: 'rgba(255,255,255,0.92)', fontSize: '.98rem' }}>{text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</div>



  {/* How It Works – Your Video in 3 Simple Steps */}
<div
  style={{
    background: '#E0ECFC',
    padding: '4.5rem 6%',
    fontFamily:
      'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    color: '#4F5962',
  }}
>
  {/* Inner max-width wrapper so it doesn’t stretch too wide */}
  <div style={{ maxWidth: 1200, margin: '0 auto' }}>
    {/* Section label */}
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '1rem',
      }}
    >
      <span
        aria-hidden
        style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: '#DF7C52', // brand accent dot
          display: 'inline-block',
        }}
      />
      <span style={{ fontSize: '0.95rem', fontWeight: 600 }}>How It Works</span>
    </div>

    {/* Header row */}
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '1rem',
        flexWrap: 'wrap',
        marginBottom: '1.75rem',
      }}
    >
      {/* Main heading */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '.25rem',
        }}
      >
        <div
          style={{
            fontSize: 'clamp(1.8rem, 6vw, 2.25rem)',
            lineHeight: 1.15,
            fontWeight: 800,
            letterSpacing: '-0.01em',
            color: '#4F5962',
          }}
        >
          Your Video in
        </div>
        <div
          style={{
            marginTop: '.1rem',
            fontSize: 'clamp(1.8rem, 6vw, 2.25rem)',
            lineHeight: 1.15,
            fontWeight: 800,
            fontStyle: 'italic',
            color: '#874B9E',
            letterSpacing: '-0.01em',
          }}
        >
          3 Simple Steps
        </div>
      </div>

      {/* Kicker */}
      <p
        style={{
          margin: 0,
          fontSize: '1.05rem',
          lineHeight: 1.5,
          color: '#4F5962',
          maxWidth: 360,
        }}
      >
        From idea to production-ready plan
      </p>
    </div>

    {/* Cards with explanations (starting with Shot List) */}
    <div
      style={{
        display: 'grid',
        // 👇 This is the big mobile fix
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '1.25rem',
      }}
    >
      {/* Card 1 – Shot List */}
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: 14,
          boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
          padding: '1.25rem',
          minHeight: 340,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {/* step badge */}
        <div
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            padding: '8px 10px',
            borderRadius: 8,
            background: '#2E3446',
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: '0.95rem',
            lineHeight: 1,
          }}
        >
          1
        </div>

        {/* illustration */}
        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            paddingTop: 24,
            paddingBottom: 24,
          }}
        >
          <img
            src={shotlistImg}
            alt="Shot List"
            style={{ width: 160, height: 'auto', objectFit: 'contain', maxWidth: '100%' }}
          />
        </div>

        {/* caption + copy */}
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              fontSize: '1.4rem',
              fontWeight: 700,
              color: '#4F5962',
              paddingTop: 8,
            }}
          >
            Shot List
          </div>
          <p
            style={{
              fontSize: '.95rem',
              lineHeight: 1.45,
              color: '#91989E',
              marginTop: 4,
            }}
          >
            Generate a detailed shot list that keeps your team aligned and every frame accounted
            for.
          </p>
        </div>
      </div>

      {/* Card 2 – Storyboard */}
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: 14,
          boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
          padding: '1.25rem',
          minHeight: 340,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            padding: '8px 10px',
            borderRadius: 8,
            background: '#2E3446',
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: '0.95rem',
            lineHeight: 1,
          }}
        >
          2
        </div>

        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            paddingTop: 24,
            paddingBottom: 24,
          }}
        >
          <img
            src={storyboardImg}
            alt="Storyboard"
            style={{ width: 160, height: 'auto', objectFit: 'contain', maxWidth: '100%' }}
          />
        </div>

        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              fontSize: '1.4rem',
              fontWeight: 700,
              color: '#4F5962',
              paddingTop: 8,
            }}
          >
            Storyboard
          </div>
          <p
            style={{
              fontSize: '.95rem',
              lineHeight: 1.45,
              color: '#91989E',
              marginTop: 4,
            }}
          >
            Map out your story visually and bring clarity to your shot ideas before production
            begins.
          </p>
        </div>
      </div>

      {/* Card 3 – RFP */}
      <div
        style={{
          background: '#FFFFFF',
          borderRadius: 14,
          boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
          padding: '1.25rem',
          minHeight: 340,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            padding: '8px 10px',
            borderRadius: 8,
            background: '#2E3446',
            color: '#FFFFFF',
            fontWeight: 700,
            fontSize: '0.95rem',
            lineHeight: 1,
          }}
        >
          3
        </div>

        <div
          style={{
            display: 'grid',
            placeItems: 'center',
            paddingTop: 24,
            paddingBottom: 24,
          }}
        >
          <img
            src={rfpImg}
            alt="RFP"
            style={{ width: 160, height: 'auto', objectFit: 'contain', maxWidth: '100%' }}
          />
        </div>

        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              fontSize: '1.4rem',
              fontWeight: 700,
              color: '#4F5962',
              paddingTop: 8,
            }}
          >
            RFP
          </div>
          <p
            style={{
              fontSize: '.95rem',
              lineHeight: 1.45,
              color: '#91989E',
              marginTop: 4,
            }}
          >
            Export a ready-to-send proposal or RFP with budgets, logistics, and deliverables built
            in.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


 {/* CTA: Learn how AJ & Ari can grow your business */}
<div
  style={{
    padding: '0 6%',                // outer breathing room
    margin: '4rem 0',              // vertical spacing only
    display: 'flex',
    justifyContent: 'center',      // center the inner container
  }}
>
  <div
    style={{
      width: '100%',
      maxWidth: '960px',            // ✅ narrower than 1200px
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '2rem',
      background: '#5D2F82',
      borderRadius: '12px',
      padding: '3rem clamp(1.75rem, 5vw, 3.5rem)',
      color: '#FFFFFF',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }}
  >
    {/* Left content */}
    <div
      style={{
        flex: '1 1 260px',
        minWidth: 0,
        maxWidth: 500,
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
      }}
    >
      <h2
        style={{
          fontSize: 'clamp(1.6rem, 3.8vw, 2.25rem)',
          lineHeight: 1.2,
          fontWeight: 600,
          margin: 0,
        }}
      >
        Learn how <span style={{ fontStyle: 'italic' }}>AJ & Ari</span> can
        <br />
        grow your business
      </h2>

      <Button
        onClick={() =>
          window.open('https://calendly.com/ceo-nxtvid/demo', '_blank')
        }
        type="destructive"
        label="Book a Demo Today"
      />
    </div>

    {/* Right image side */}
    <div
      style={{
        flex: '1 1 260px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
        position: 'relative',
        minWidth: 0,
        paddingRight: '1.5rem',
        boxSizing: 'border-box',
      }}
    >
      <img
        src={ariAvatar}
        alt="Ari"
        style={{
          height: 'clamp(160px, 22vw, 240px)',
          width: 'auto',
          objectFit: 'contain',
          zIndex: 2,
          position: 'relative',
          right: '-10px',
        }}
      />
      <img
        src={ajAvatar}
        alt="AJ"
        style={{
          height: 'clamp(160px, 22vw, 240px)',
          width: 'auto',
          objectFit: 'contain',
          zIndex: 1,
          position: 'relative',
          left: '-35px',
        }}
      />
    </div>
  </div>
</div>



<TestimonialsSection  testimonials={testimonials}/>




  {/* Why Now / Who We Help / Why We Care */}
<div
  style={{
    padding: '4.5rem clamp(1.75rem, 6vw, 6%) 4rem',
    fontFamily:
      'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    color: '#4F5962',
  }}
>
  <div style={{ maxWidth: 1200, margin: '0 auto' }}>
    {/* Header */}
    <div style={{ textAlign: 'center', marginBottom: '1.25rem' }}>
      <h2
        style={{
          margin: 0,
          color: '#874B9E',
          fontSize: 'clamp(1.8rem, 5vw, 3rem)',
          fontWeight: 800,
          letterSpacing: '-0.01em',
        }}
      >
        Why Now?&nbsp;&nbsp; Who We Help?&nbsp;&nbsp; Why We Care?
      </h2>
      <p
        style={{
          margin: '12px 0 0',
          color: '#1f2937',
          opacity: 0.82,
          fontSize: '1.05rem',
        }}
      >
        From idea to final cut — faster than ever.
      </p>
    </div>

    {/* Cards */}
    <div
      style={{
        display: 'grid',
        // ✅ Responsive: 1 column on small, 2–3 as space allows
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '1.5rem',
        marginTop: '1.25rem',
      }}
    >
      {/* Card 1 — Why Now */}
      <div
        style={{
          background: '#2E3446',
          color: '#fff',
          borderRadius: 12,
          padding: '2rem',
          boxShadow: '0 10px 28px rgba(0,0,0,0.20)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
        }}
      >
        {/* Icon disk */}
        <div
          style={{
            width: 128,
            height: 128,
            borderRadius: '50%',
            background: '#FFFFFF',
            display: 'grid',
            placeItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={calendarImg}
            alt=""
            style={{ width: 82, height: 82, objectFit: 'contain', maxWidth: '100%' }}
          />
        </div>

        {/* Divider */}
        <div
          style={{
            height: 1,
            background:
              'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.16), rgba(255,255,255,0.06))',
            marginTop: '0.25rem',
          }}
        />

        {/* Text */}
        <div>
          <div
            style={{
              color: '#DF7C52',
              fontSize: 'clamp(1.4rem, 4.5vw, 1.8rem)',
              fontWeight: 800,
              marginBottom: '.35rem',
            }}
          >
            Why Now?
          </div>
          <div style={{ fontWeight: 800, marginBottom: '.35rem' }}>
            91% of Business use Video
          </div>
          <p
            style={{
              margin: 0,
              color: 'rgba(255,255,255,0.88)',
              lineHeight: 1.6,
              fontSize: '.98rem',
            }}
          >
            Video is no longer optional — 91% of businesses already use it. The
            problem? Pre-production has been slow, expensive, and stressful.
            NXTVid makes planning faster, cheaper, and smarter.
          </p>
        </div>

        {/* Bottom hairline */}
        <div
          style={{
            marginTop: '1rem',
            height: 1,
            background:
              'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />
      </div>

      {/* Card 2 — Who We Help */}
      <div
        style={{
          background: '#2E3446',
          color: '#fff',
          borderRadius: 12,
          padding: '2rem',
          boxShadow: '0 10px 28px rgba(0,0,0,0.20)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
        }}
      >
        <div
          style={{
            width: 128,
            height: 128,
            borderRadius: '50%',
            background: '#FFFFFF',
            display: 'grid',
            placeItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={handshakeImg}
            alt=""
            style={{ width: 82, height: 82, objectFit: 'contain', maxWidth: '100%' }}
          />
        </div>

        <div
          style={{
            height: 1,
            background:
              'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.16), rgba(255,255,255,0.06))',
            marginTop: '0.25rem',
          }}
        />

        <div>
          <div
            style={{
              color: '#DF7C52',
              fontSize: 'clamp(1.4rem, 4.5vw, 1.8rem)',
              fontWeight: 800,
              marginBottom: '.35rem',
            }}
          >
            Who We Help?
          </div>
          <div style={{ fontWeight: 800, marginBottom: '.35rem' }}>
            80%+ efficiency
          </div>
          <p
            style={{
              margin: 0,
              color: 'rgba(255,255,255,0.88)',
              lineHeight: 1.6,
              fontSize: '.98rem',
            }}
          >
            Ari helps you handle the nuts and bolts: timelines, budgets,
            logistics and deliverables. She transforms your rough ideas into
            professional, shareable PDFs.
          </p>
        </div>

        <div
          style={{
            marginTop: '1rem',
            height: 1,
            background:
              'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />
      </div>

      {/* Card 3 — Why We Care */}
      <div
        style={{
          background: '#2E3446',
          color: '#fff',
          borderRadius: 12,
          padding: '2rem',
          boxShadow: '0 10px 28px rgba(0,0,0,0.20)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem',
        }}
      >
        <div
          style={{
            width: 128,
            height: 128,
            borderRadius: '50%',
            background: '#FFFFFF',
            display: 'grid',
            placeItems: 'center',
            overflow: 'hidden',
          }}
        >
          <img
            src={heartMailImg}
            alt=""
            style={{ width: 82, height: 82, objectFit: 'contain', maxWidth: '100%' }}
          />
        </div>

        <div
          style={{
            height: 1,
            background:
              'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.16), rgba(255,255,255,0.06))',
            marginTop: '0.25rem',
          }}
        />

        <div>
          <div
            style={{
              color: '#DF7C52',
              fontSize: 'clamp(1.4rem, 4.5vw, 1.8rem)',
              fontWeight: 800,
              marginBottom: '.35rem',
            }}
          >
            Why We Care
          </div>
          <div style={{ fontWeight: 800, marginBottom: '.35rem' }}>
            We’ve lived the pain.
          </div>
          <p
            style={{
              margin: 0,
              color: 'rgba(255,255,255,0.88)',
              lineHeight: 1.6,
              fontSize: '.98rem',
            }}
          >
            Businesses lose money without strategy, and creators drown in
            back-and-forth. NXTVid fixes this by empowering both brands and
            creators to succeed together.
          </p>
        </div>

        <div
          style={{
            marginTop: '1rem',
            height: 1,
            background:
              'linear-gradient(90deg, rgba(255,255,255,0.06), rgba(255,255,255,0.12), rgba(255,255,255,0.06))',
          }}
        />
      </div>
    </div>
  </div>
</div>


{/* CTA – Start Creating Smarter Videos Today */}
<div
  style={{
    padding: '2.5rem clamp(1.75rem, 6vw, 6%)',
    fontFamily:
      'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  }}
>
  <div
    style={{
      maxWidth: 1200,
      margin: '0 auto',
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      gap: '2rem',
      flexWrap: 'wrap', // ✅ lets it stack on mobile
      background: '#2F3645',
      color: '#fff',
      borderRadius: 14,
      overflow: 'hidden',
      boxSizing: 'border-box',
      padding: '2.5rem clamp(1.75rem, 5vw, 3rem)',
    }}
  >
    {/* Left: copy + actions */}
    <div
      style={{
        flex: '1 1 260px',
        minWidth: 0,
        maxWidth: 680,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: 'clamp(2rem, 4.5vw, 3.25rem)',
          lineHeight: 1.15,
          fontWeight: 800,
          letterSpacing: '-0.01em',
        }}
      >
        Start Creating Smarter
        <br />
        Videos{' '}
        <span style={{ fontStyle: 'italic', fontWeight: 800 }}>
          Today
        </span>
      </h2>

      <p
        style={{
          margin: '1.25rem 0 0',
          fontSize: '1.05rem',
          lineHeight: 1.6,
          color: 'rgba(255,255,255,0.9)',
          maxWidth: 600,
        }}
      >
        Join thousands of creators and businesses already using NxtVid
        to save time and grow faster.
      </p>

      {/* Actions */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          marginTop: '1.75rem',
          flexWrap: 'wrap',
        }}
      >
        <Button
          label="Start Planning Today"
          type="primary"
          onClick={() => mastheadRef?.current?.triggerSignUpModal?.()}
        />
        <Button
          label="Book a Demo"
          type="destructive"
          onClick={() =>
            window.open('https://calendly.com/ceo-nxtvid/demo', '_blank')
          }
        />
      </div>
    </div>

    {/* Right: fabric visual */}
    <div
      style={{
        flex: '1 1 260px',
        minWidth: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      <img
        src={ctaFabricImg}
        alt=""
        style={{
          width: '100%',
          maxWidth: 640,
          height: 'auto',
          objectFit: 'cover',
          borderRadius: 12,
          transform: 'translateX(6%)',
        }}
      />
    </div>
  </div>
</div>



  </div>
</body>
    }
     <footer>
      <Footer/>
      </footer> 
    </div>
  );
};

export default Home;
